import { Logo, LogoKeyline, GroupLogo, GroupLogoMasthead, GroupWordmark, Wordmark, WordmarkStacked } from '@economist/design-system/dist/umd/common';
import * as React from 'react';
export default {
  Logo,
  LogoKeyline,
  GroupLogo,
  GroupLogoMasthead,
  GroupWordmark,
  Wordmark,
  WordmarkStacked,
  React
};